<template>
  <div class="mb-3">
    <b-form-group
      :class="title_position"
      id="example text"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      <b-form-checkbox
        :class="{ 'is-invalid': v.$error }"
        value="true"
        unchecked-value="false"
        v-model="InputName"
        :disabled="FormDataType.Disabled"
        class="mb-3"
        @input="$emit('input', $event)"
        :checked="InputName"
        plain
      ></b-form-checkbox>
      <template v-if="v.$error">
        <div v-for="(error, index) of v.$silentErrors" :key="index">
          <div>
            <span v-if="error.$validator == 'required'">{{
              $t("ValidationMessage.required")
            }}</span>
            <span v-else>{{ error.$message }}</span>
          </div>
        </div>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      InputName: false,
    };
  },
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: Boolean,
    title_position: String,
    labels_lg: Number,
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value() {
      this.InputName = this.Value;
    },
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
